export enum ExtCircType {
  Unknown = 0,
  Extension = 1,
  Reduction = 2
}
